import { ReactNode } from "react";

interface ModalHeroProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
}

// Full-bleed dark header used as a modal title; styles live in theme/shadcn.css (.modal-hero).
export const ModalHeroComponent = ({ icon, title, subtitle }: ModalHeroProps) => (
  <div className="modal-hero">
    <div className="modal-hero-icon">{icon}</div>
    <div>
      <div className="modal-hero-title">{title}</div>
      {subtitle && <div className="modal-hero-subtitle">{subtitle}</div>}
    </div>
  </div>
);
